// Fetch items
export const FETCH_REQUESTED = 'fate/FETCH_REQUESTED';
export const FETCH_SUCCESS = 'fate/FETCH_SUCCESS';
export const FETCH_FAILURE = 'fate/FETCH_FAILURE';

// Purchase an item
export const PURCHASE_ITEM_REQUESTED = 'fate/PURCHASE_ITEM_REQUESTED';
export const PURCHASE_ITEM_SUCCESS = 'fate/PURCHASE_ITEM_SUCCESS';
export const PURCHASE_ITEM_FAILURE = 'fate/PURCHASE_ITEM_FAILURE';

// process fate change
export const PROCESS_FATE_CHANGE = 'fate/PROCESS_FATE_CHANGE';

// Set active subtab on the Fate tab
export const SET_ACTIVE_SUBTAB = 'fate/SET_ACTIVE_SUBTAB';

export const TOGGLE_ENHANCED_STORE = 'fate/TOGGLE_ENHANCED_STORE';
